import React from 'react';
import { Menu } from 'antd';
import LockResetIcon from 'mdi-react/LockResetIcon';
import AccountRemoveIcon from 'mdi-react/AccountRemoveIcon';
import PowerIcon from 'mdi-react/PowerIcon';
import AccountIcon from 'mdi-react/AccountIcon';
import ProgressWrenchIcon from 'mdi-react/ProgressWrenchIcon';
import PropTypes from 'prop-types';
import { getUserPermissions } from '../../utils/users';
import './HeaderMenu.scss';

const HeaderMenu = (
  props: {
    user?: any,
    onClick: (args?: any | undefined) => any
  },
): JSX.Element => {
  const { onClick } = props;

  return (
    <Menu
      className="custom-header-menu"
      onClick={onClick}
      items={[
        ((getUserPermissions() || []).includes('Meu perfil'))
          ? ({
            className: 'profile-edit',
            key: 'profileEdit',
            icon: (<AccountIcon />),
            label: (<span>Meu perfil</span>),
          })
          : null,

        ((getUserPermissions() || []).includes('Alterar senha'))
          ? ({
            className: 'change-password',
            key: 'changePassword',
            icon: (<LockResetIcon />),
            label: (<span>Alterar senha</span>),
          })
          : null,
        ((getUserPermissions() || []).includes('Excluir conta'))
          ? ({
            className: 'deleteAccount',
            key: 'deleteAccount',
            icon: (<AccountRemoveIcon />),
            label: (<span>Excluir conta</span>),
          }) : null,

        ((getUserPermissions() || []).includes('Notificações'))
          ? ({
            className: 'notificationsettings',
            key: 'notificationsettings',
            icon: (<ProgressWrenchIcon />),
            label: (<span>Configurar notificações</span>),
          })
          : null,

        {
          className: 'logout',
          key: 'logout',
          icon: (<PowerIcon />),
          label: 'Sair',
        },
      ]}
    />
  );
};

HeaderMenu.propTypes = {
  onClick: PropTypes.func.isRequired,
};

HeaderMenu.defaultProps = {
  user: undefined,
};

export default HeaderMenu;
